<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="size" :height="size" viewBox="0 0 24 24"
       fill="none" stroke="currentColor" :stroke-width="strokeWidth"
       stroke-linecap="round" stroke-linejoin="round" class="yn-svg-icon yn-svg-icon-arrow-up">
    <line x1="12" y1="19" x2="12" y2="5" />
    <polyline points="5 12 12 5 19 12" />
  </svg>
</template>

<script setup>
defineProps({
  size: { type: [Number, String], default: 16 },
  strokeWidth: { type: [Number, String], default: 2 },
})
</script>
